import { DistributorApiHealthStatus } from "@src/constants/DistributorApiHealthStatuses";
import request from "@src/utils/request";

export function getDistributorApiHealthStatuses(): Promise<
  ApiResponse<DistributorApiHealthStatus[]>
> {
  return request().get("/api/v1/distributor-api-health-statuses/").send();
}

export function setPreferredDistributor(
  distributorSlug: string,
  isPreferred: boolean,
) {
  return request()
    .patch(`/api/v1/distributors/${distributorSlug}/set-is-preferred/`)
    .send({ is_preferred: isPreferred });
}

export interface DistributorTermsFilters {
  distributor?: string;
  page?: number;
  pageSize?: number;
}

export function listDistributorTerms(filters: DistributorTermsFilters = {}) {
  return request()
    .query(filters)
    .get("/api/v1/distributor-terms/")
    .send()
    .then((response: any) => {
      return response;
    });
}

export interface UserDistributorTermsAgreementsFilters {
  distributor?: string;
}

export function listUserDistributorTermsAgreements(
  filters: UserDistributorTermsAgreementsFilters = {},
) {
  return request()
    .query(filters)
    .get("/api/v1/user-distributor-terms-agreements/")
    .send()
    .then((response: any) => {
      return response;
    });
}

export interface CreateUserDistributorTermsAgreementPayload {
  distributor: string;
  distributor_terms: string;
}

export function createUserDistributorTermsAgreement(
  payload: CreateUserDistributorTermsAgreementPayload,
) {
  return request()
    .post("/api/v1/user-distributor-terms-agreements/")
    .send(payload);
}
